import React, { FC } from "react";

export interface EventMarkerDisplayDocsProps {
  label: string;
  downloadRequest: Function;
  showMore: Function;
}

export const EventMarkerDisplayDocs: FC<EventMarkerDisplayDocsProps> = (
  props
) => {
  const { label, downloadRequest, showMore } = props;

  let docs: string[] = label ? label.split(";") : [];
  let showMoreLink: boolean = docs && docs !== null ? docs.length > 3 : false;

  let attch = docs.map((d, idx) => {
    if (idx <= 1 || !showMoreLink) {
      return (
        <div key={idx}
            onClick={() => {
              downloadRequest(d);
            }}
            className="linkCursor"
            style={{ textAlign: "right"}}
          >
            {d}
        </div>
      );
    }
  });

  let more = <div></div>;
  if (showMoreLink) {
    more = <div onClick={() => {showMore(label)}} style={{ textAlign: "right", cursor: "pointer"}}>Click for full list...</div>
  }

  return <div style={{overflowY:'auto', overflowX: "hidden", height: '65px', paddingTop:'5px'}}>{attch}{more}</div>;
};
export default EventMarkerDisplayDocs;
